import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader, isDestinationValid } from "../Helpers";
import { STR_REQUEST_RIDE, STR_SUBMIT, STR_PICKUP_LOCATION, STR_DESTINY_LOCATION, STR_RIDE, STR_DELIVERY, STR_WHERE_TO, STR_INVALID_RIDE_TYPE, STR_INVALID_FROM_DESTINATION, STR_INVALID_TO_DESTINATION, STR_SUCCESSFULLY_SENT, STR_WHERE_FROM, STR_USE_CURRENT_LOCATION, STR_BODA_DESC, STR_BAJAJ_DESC, STR_CAB_DESC, STR_CONFIRM_ORDER, STR_PER_KM, STR_MAP_HELPER_TEXT, STR_CONTINUE, STR_CONFIRM_ORDER2, STR_CONFIRM_ORDER_HELP_TEXT, STR_DISTANCE, STR_ESTIMATED_COST_TZS, STR_CHOOSE_RIDER_TYPE } from "../Strings";
import { FaMapMarkerAlt, FaLocationArrow, FaCar, FaBox, FaSearch, FaMotorcycle, FaTaxi, FaArrowLeft, FaCheckCircle } from "react-icons/fa";

import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';



const markerIcon = new L.Icon({
	iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
	shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
	iconSize: [25, 41],
	iconAnchor: [12, 41],
	popupAnchor: [1, -34],
	shadowSize: [41, 41],
});

function MapClickHandler({ onPick }) {
	useMapEvents({
		click(e) {
			onPick(e.latlng.lat, e.latlng.lng);
		}
	});

	return null;
}

function MapUpdater({ destination }) {
	const map = useMap();

	useEffect(() => {
		if(destination && destination.lat && destination.lng) {
			map.setView([destination.lat, destination.lng], 16);
		}
	}, [destination])

	return null;
}

function LocationSearchBox({
	type,
	value,
	placeholder,
	searchingPlaces,
	placeSuggestions,
	onChange,
	onUseCurrentLocation,
	onPickSuggestedPlace,
}) {

	const appContext = useContext(AppContext);

	return (
		<div
			style={{
				width: "100%",
				marginTop: 14,
				background: "var(--lightColor)",
				borderRadius: 18,
				padding: 12,
			}}
		>
			<h6
				style={{
					fontSize: "18px",

				}}
			>
				{placeholder}
			</h6>

			<div
				style={{
					display: "flex",
					alignItems: "center",
					background: "var(--surfaceColor)",
					border: "1px solid var(--borderColor)",
					borderRadius: 16,
					padding: "11px 13px",
				}}
			>
				<FaSearch
					style={{
						opacity: .55,
						marginRight: 10,
					}}
				/>

				<input
					value={value}
					onChange={e => onChange(e.target.value, type)}
					placeholder={placeholder}
					className="form-control"
					style={{
						border: "none",
						padding: 5,
						boxShadow: "none",
						background: "transparent",
						fontSize: 14,
					}}
				/>
			</div>

			<button
				type="button"
				onClick={() => onUseCurrentLocation(type)}
				className="btn btn-outline-primary"
				style={{
					borderRadius: 16,
					padding: "10px 12px",
					fontSize: 13,
					marginTop: 10,
					width: "100%",
				}}
			>
				<FaLocationArrow style={{ marginRight: 8 }} />
				{STR_USE_CURRENT_LOCATION[appContext.language]}
			</button>

			{(searchingPlaces || placeSuggestions.length > 0) && (
				<div
					style={{
						background: "var(--surfaceColor)",
						border: "1px solid var(--borderColor)",
						borderRadius: 16,
						marginTop: 10,
						overflow: "hidden",
					}}
				>
					{searchingPlaces && (
						<div
							style={{
								padding: 12,
								fontSize: 13,
								opacity: .7,
							}}
						>
							Searching...
						</div>
					)}

					{placeSuggestions.map((item, index) => (
						<div
							key={index}
							onClick={() => onPickSuggestedPlace(item)}
							style={{
								display: "flex",
								alignItems: "center",
								padding: 12,
								cursor: "pointer",
								borderBottom: index === placeSuggestions.length - 1 ? "none" : "1px solid var(--borderColor)",
							}}
						>
							<div
								style={{
									width: 34,
									height: 34,
									borderRadius: 17,
									background: "var(--lightColor)",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									marginRight: 10,
									color: "var(--primaryColor)",
								}}
							>
								<FaMapMarkerAlt />
							</div>

							<div style={{ flex: 1 }}>
								<div
									style={{
										fontSize: 14,
										fontWeight: "bold",
									}}
								>
									{item.structured_formatting && item.structured_formatting.main_text
										? item.structured_formatting.main_text
										: item.description}
								</div>

								<div
									style={{
										fontSize: 12,
										opacity: .7,
									}}
								>
									{item.description}
								</div>
							</div>
						</div>
					))}
				</div>
			)}
		</div>
	)
}

async function calculateGoogleRouteDistance(destinationA, destinationB, mapsApiKey) {
	if(
		!destinationA ||
		!destinationB ||
		destinationA.lat === undefined ||
		destinationA.lng === undefined ||
		destinationB.lat === undefined ||
		destinationB.lng === undefined
	) {
		return null;
	}

	const lat1 = Number(destinationA.lat);
	const lng1 = Number(destinationA.lng);
	const lat2 = Number(destinationB.lat);
	const lng2 = Number(destinationB.lng);

	if(
		isNaN(lat1) ||
		isNaN(lng1) ||
		isNaN(lat2) ||
		isNaN(lng2)
	) {
		return null;
	}

	if(typeof window === "undefined") {
		return null;
	}

	if(!(window.google && window.google.maps && window.google.maps.DirectionsService)) {
		return null;
	}

	return new Promise(resolve => {
		const directionsService = new window.google.maps.DirectionsService();

		directionsService.route({
			origin: {
				lat: lat1,
				lng: lng1,
			},
			destination: {
				lat: lat2,
				lng: lng2,
			},
			travelMode: window.google.maps.TravelMode.DRIVING,
		}, (result, status) => {
			if(status === "OK" && result && result.routes && result.routes.length > 0) {
				const route = result.routes[0];

				let distanceMeters = 0;
				let durationSeconds = 0;

				if(route.legs && route.legs.length > 0) {
					for(const leg of route.legs) {
						if(leg.distance && leg.distance.value) {
							distanceMeters += leg.distance.value;
						}

						if(leg.duration && leg.duration.value) {
							durationSeconds += leg.duration.value;
						}
					}
				}

				const distanceKm = distanceMeters / 1000;
				const durationMinutes = durationSeconds / 60;

				resolve({
					meters: Number(distanceMeters.toFixed(2)),
					kilometers: Number(distanceKm.toFixed(2)),
					durationSeconds: Number(durationSeconds.toFixed(0)),
					durationMinutes: Number(durationMinutes.toFixed(0)),
					distanceText: distanceKm >= 1
						? `${distanceKm.toFixed(2)} km`
						: `${distanceMeters.toFixed(0)} m`,
					durationText: `${durationMinutes.toFixed(0)} min`,
					type: "road",
				});
			} else {
				resolve(null);
			}
		});
	});
}



export default function View(props) {
	const appContext = useContext(AppContext);
	const scrollContainerRef = useRef(null);

	const [loading, setLoading] = useState(false);
	const [ready, setReady] = useState(false);

	const [requestStage, setRequestStage] = useState(1);

	const [rideType, setRideType] = useState('ride');
	const [riderType, setRiderType] = useState('boda');

	const [fromDestination, setFromDestination] = useState(null);
	const [toDestination, setToDestination] = useState(null);

	const [activeDestination, setActiveDestination] = useState('from');

	const [fromDescription, setFromDescription] = useState('');
	const [toDescription, setToDescription] = useState('');

	const [placeSuggestions, setPlaceSuggestions] = useState([]);
	const [searchingPlaces, setSearchingPlaces] = useState(false);
	const [googleMapsReady, setGoogleMapsReady] = useState(false);

	const [totalDistance, setTotalDistance] = useState(0);
	const [routeDistanceData, setRouteDistanceData] = useState(null);

	const defaultCenter = [-6.7924, 39.2083];

	async function init() {
		setReady(false);
		await loadGoogleMapsScript();
		setReady(true)
	}

	function scrollToTop() {
		if(scrollContainerRef.current) {
			scrollContainerRef.current.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		}
	}

	function loadGoogleMapsScript() {
		return new Promise(resolve => {
			if(window.google && window.google.maps && window.google.maps.places) {
				setGoogleMapsReady(true);
				resolve(true);
				return;
			}

			if(!(appContext.systemParams && appContext.systemParams.mapsApiKey)) {
				resolve(false);
				return;
			}

			const existingScript = document.getElementById("google-maps-script");

			if(existingScript) {
				const interval = setInterval(() => {
					if(window.google && window.google.maps && window.google.maps.places) {
						clearInterval(interval);
						setGoogleMapsReady(true);
						resolve(true);
					}
				}, 300);

				setTimeout(() => {
					clearInterval(interval);
					resolve(false);
				}, 8000);

				return;
			}

			const script = document.createElement("script");
			script.id = "google-maps-script";
			script.src = `https://maps.googleapis.com/maps/api/js?key=${appContext.systemParams.mapsApiKey}&libraries=places`;
			script.async = true;
			script.defer = true;

			script.onload = () => {
				setGoogleMapsReady(true);
				resolve(true);
			}

			script.onerror = () => {
				resolve(false);
			}

			document.body.appendChild(script);
		});
	}

	function getActiveDescription() {
		if(activeDestination === 'from') {
			return fromDescription;
		}

		return toDescription;
	}

	function getActiveDestinationData() {
		if(activeDestination === 'from') {
			return fromDestination;
		}

		return toDestination;
	}

	function getMapDestinationData() {
		if(getActiveDestinationData()) {
			return getActiveDestinationData();
		}

		if(fromDestination) {
			return fromDestination;
		}

		if(toDestination) {
			return toDestination;
		}

		return null;
	}

	function getAmount(value) {
		const amount = Number(value);

		if(isNaN(amount)) {
			return 0;
		}

		return amount;
	}

	function getPricePerKilometer() {
		if(riderType === 'boda') {
			return getAmount(appContext.systemParams.pricePerKilometerBoda);
		}

		if(riderType === 'bajaj') {
			return getAmount(appContext.systemParams.pricePerKilometerBajaj);
		}

		return getAmount(appContext.systemParams.pricePerKilometerCab);
	}

	function getEstimatedCost() {
		const distance = getAmount(totalDistance);
		const pricePerKilometer = getPricePerKilometer();

		return distance * pricePerKilometer;
	}

	function formatMoney(value) {
		const amount = getAmount(value);

		return amount.toLocaleString();
	}

	function getDistanceText() {
		if(routeDistanceData && routeDistanceData.distanceText) {
			return routeDistanceData.distanceText;
		}

		const distanceKm = getAmount(totalDistance);
		const distanceMeters = distanceKm * 1000;

		if(distanceKm >= 1) {
			return `${distanceKm.toFixed(2)} km`;
		}

		return `${distanceMeters.toFixed(0)} m`;
	}

	function getRiderTypeName(type) {
		if(type === 'boda') {
			return 'Boda';
		}

		if(type === 'bajaj') {
			return 'Bajaj';
		}

		return 'Cab';
	}

	function setDestinationData(lat, lng, description = '', type = activeDestination, updateSearchBox = true) {
		let data = {
			lat,
			lng,
			description,
		};

		setRequestStage(1);
		setRouteDistanceData(null);
		setTotalDistance(0);

		if(type === 'from') {
			setFromDestination(data);

			if(updateSearchBox) {
				setFromDescription(description);
			}
		} else {
			setToDestination(data);

			if(updateSearchBox) {
				setToDescription(description);
			}
		}
	}

	async function reverseGeocode(lat, lng) {
		return new Promise(resolve => {
			let description = `${lat}, ${lng}`;

			if(window.google && window.google.maps) {
				const geocoder = new window.google.maps.Geocoder();

				geocoder.geocode({
					location: {
						lat,
						lng,
					}
				}, (results, status) => {
					if(status === "OK" && results && results.length > 0) {
						resolve(results[0].formatted_address);
					} else {
						resolve(description);
					}
				});
			} else {
				resolve(description);
			}
		});
	}

	async function pickMapLocation(lat, lng) {
		const description = await reverseGeocode(lat, lng);
		setDestinationData(lat, lng, description);
		setPlaceSuggestions([]);
	}

	function pickCurrentLocation(type = activeDestination) {

		appContext.tellError("Not supported");
		return;

		if(navigator.geolocation) {
			setLoading(true);

			navigator.geolocation.getCurrentPosition(async position => {
				const lat = position.coords.latitude;
				const lng = position.coords.longitude;
				const description = await reverseGeocode(lat, lng);

				setDestinationData(lat, lng, description, type);
				setPlaceSuggestions([]);
				setLoading(false);
			}, error => {
				setLoading(false);
				appContext.tellError(error.message);
			}, {
				enableHighAccuracy: true,
			});
		}
	}

	function updateDescription(value, type) {
		setActiveDestination(type);
		setRequestStage(1);
		setRouteDistanceData(null);
		setTotalDistance(0);

		if(type === 'from') {
			setFromDescription(value);
		} else {
			setToDescription(value);
		}
	}

	function searchPlaces(value, type) {
		setActiveDestination(type);

		if(value.trim().length < 2) {
			setPlaceSuggestions([]);
			return;
		}

		if(!(googleMapsReady && window.google && window.google.maps && window.google.maps.places)) {
			setPlaceSuggestions([]);
			return;
		}

		setSearchingPlaces(true);

		const service = new window.google.maps.places.AutocompleteService();

		service.getPlacePredictions({
			input: value,
			componentRestrictions: {
				country: "tz",
			}
		}, (predictions, status) => {
			if(status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
				setPlaceSuggestions(predictions);
			} else {
				setPlaceSuggestions([]);
			}

			setSearchingPlaces(false);
		});
	}

	function pickSuggestedPlace(place) {
		if(!(window.google && window.google.maps && window.google.maps.places)) {
			return;
		}

		setLoading(true);

		const selectedSearchText = getActiveDescription();

		const placesService = new window.google.maps.places.PlacesService(document.createElement("div"));

		placesService.getDetails({
			placeId: place.place_id,
			fields: ["name", "formatted_address", "geometry"],
		}, (result, status) => {
			if(status === window.google.maps.places.PlacesServiceStatus.OK && result && result.geometry) {
				const lat = result.geometry.location.lat();
				const lng = result.geometry.location.lng();

				const placeName = result.name || selectedSearchText || place.description;
				const placeAddress = result.formatted_address || place.description;

				let description = placeName;

				if(placeAddress && placeAddress.trim().length > 0 && placeAddress !== placeName) {
					description = `${placeName} (${placeAddress})`;
				}

				setDestinationData(lat, lng, description, activeDestination, false);

				if(activeDestination === 'from') {
					setFromDescription(selectedSearchText);
				} else {
					setToDescription(selectedSearchText);
				}

				setPlaceSuggestions([]);
			}

			setLoading(false);
		});
	}

	function getDestinationDisplay(destination, placeholder) {
		if(destination && destination.description && destination.description.trim().length > 0) {
			return destination.description;
		}

		return placeholder;
	}

	function renderDestinationBlock({
		type,
		title,
		placeholder,
		destination,
		icon,
		hasBorder = false,
	}) {
		const isActive = activeDestination === type;

		return (
			<div
				onClick={() => {
					setRequestStage(1);
					setActiveDestination(type);
				}}
				style={{
					display: "flex",
					alignItems: "flex-start",
					cursor: "pointer",
					paddingBottom: hasBorder ? 13 : 0,
					paddingTop: hasBorder ? 0 : 13,
					borderBottom: hasBorder ? "1px solid var(--borderColor)" : "none",
				}}
			>
				<div
					style={{
						width: 38,
						height: 38,
						minWidth: 38,
						borderRadius: 19,
						background: isActive ? "var(--secondaryColor)" : "var(--lightColor)",
						color: isActive ? "var(--onPrimaryColor)" : "var(--primaryColor)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						marginRight: 12,
						marginTop: 2,
					}}
				>
					{icon}
				</div>

				<div style={{ flex: 1 }}>
					<div
						style={{
							fontSize: 12,
							opacity: .7,
						}}
					>
						{title}
					</div>

					<div
						style={{
							fontSize: 14,
							fontWeight: destination ? "bold" : "normal",
							opacity: destination ? 1 : .55,
							marginTop: 2,
							lineHeight: "20px",
						}}
					>
						{getDestinationDisplay(destination, placeholder)}
					</div>
				</div>
			</div>
		)
	}

	function renderRouteTypeBlock() {
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					paddingBottom: 13,
					marginBottom: 13,
					borderBottom: "1px solid var(--borderColor)",
				}}
			>
				<div
					style={{
						width: 38,
						height: 38,
						minWidth: 38,
						borderRadius: 19,
						background: "var(--lightColor)",
						color: "var(--primaryColor)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						marginRight: 12,
					}}
				>
					{rideType === 'ride' ? <FaCar /> : <FaBox />}
				</div>

				<div style={{ flex: 1 }}>
					

					<div
						style={{
							fontSize: 18,
							marginTop: 2,
							lineHeight: "20px",
						}}
					>
						{rideType === 'ride'
							? STR_RIDE[appContext.language]
							: STR_DELIVERY[appContext.language]}
					</div>
				</div>
			</div>
		)
	}

	function renderRouteDestinationBlock({
		title,
		destination,
		icon,
		hasBorder = false,
	}) {
		return (
			<div
				style={{
					display: "flex",
					alignItems: "flex-start",
					paddingBottom: hasBorder ? 13 : 0,
					paddingTop: hasBorder ? 0 : 13,
					borderBottom: hasBorder ? "1px solid var(--borderColor)" : "none",
				}}
			>
				<div
					style={{
						width: 38,
						height: 38,
						minWidth: 38,
						borderRadius: 19,
						background: "var(--lightColor)",
						color: "var(--primaryColor)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						marginRight: 12,
						marginTop: 2,
					}}
				>
					{icon}
				</div>

				<div style={{ flex: 1 }}>
					<div
						style={{
							fontSize: 12,
							opacity: .7,
						}}
					>
						{title}
					</div>

					<div
						style={{
							fontSize: 14,
							fontWeight: "bold",
							marginTop: 2,
							lineHeight: "20px",
						}}
					>
						{destination && destination.description}
					</div>
				</div>
			</div>
		)
	}

	function renderRiderTypeOption({
		type,
		title,
		description,
		icon,
	}) {
		const isActive = riderType === type;
		const price = getAmount(type === 'boda'
			? appContext.systemParams.pricePerKilometerBoda
			: type === 'bajaj'
				? appContext.systemParams.pricePerKilometerBajaj
				: appContext.systemParams.pricePerKilometerCab
		);

		return (
			<div
				onClick={() => setRiderType(type)}
				style={{
					display: "flex",
					alignItems: "center",
					padding: 13,
					borderRadius: 18,
					cursor: "pointer",
					background: isActive ? "var(--secondaryColor)" : "var(--surfaceColor)",
					color: isActive ? "var(--onPrimaryColor)" : "inherit",
					border: isActive ? "1px solid var(--secondaryColor)" : "1px solid var(--borderColor)",
					marginBottom: 10,
				}}
			>
				<div
					style={{
						width: 42,
						height: 42,
						minWidth: 42,
						borderRadius: 21,
						background: isActive ? "rgba(255, 255, 255, .18)" : "var(--lightColor)",
						color: isActive ? "var(--onPrimaryColor)" : "var(--primaryColor)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						marginRight: 12,
						fontSize: 18,
					}}
				>
					{icon}
				</div>

				<div style={{ flex: 1 }}>
					<div
						style={{
							fontSize: 15,
							fontWeight: "bold",
						}}
					>
						{title}
					</div>

					<div
						style={{
							fontSize: 12,
							opacity: .75,
							marginTop: 2,
						}}
					>
						{description}
					</div>
				</div>

				<div
					style={{
						textAlign: "right",
						marginLeft: 10,
					}}
				>
					<div
						style={{
							fontSize: 12,
							opacity: .75,
						}}
					>
						{STR_PER_KM[appContext.language]}
					</div>

					<div
						style={{
							fontSize: 14,
							fontWeight: "bold",
						}}
					>
						{formatMoney(price)} TZS
					</div>
				</div>
			</div>
		)
	}

	async function continueToSummary() {
		if(rideType.trim().length > 0) {
			if(isDestinationValid(fromDestination)) {
				if(isDestinationValid(toDestination)) {
					setLoading(true);

					await loadGoogleMapsScript();

					const routeDistance = await calculateGoogleRouteDistance(
						fromDestination,
						toDestination,
						appContext.systemParams.mapsApiKey
					);

					if(routeDistance) {
						setRouteDistanceData(routeDistance);
						setTotalDistance(routeDistance.kilometers);
						setRequestStage(2);

						setTimeout(() => {
							scrollToTop();
						}, 100);
					} else {
						appContext.tellError("Could not calculate route distance");
					}

					setLoading(false);
				} else {
					appContext.tellError(STR_INVALID_TO_DESTINATION[appContext.language])
				}
			} else {
				appContext.tellError(STR_INVALID_FROM_DESTINATION[appContext.language])
			}
		} else {
			appContext.tellError(STR_INVALID_RIDE_TYPE[appContext.language]);
		}
	}

	async function submit() {
		if(rideType.trim().length > 0) {
			if(isDestinationValid(fromDestination)) {
				if(isDestinationValid(toDestination)) {
					if(totalDistance > 0) {
						setLoading(true);
						await callApi(
							'request-ride',
							{
								fromDestination: JSON.stringify(fromDestination),
								toDestination: JSON.stringify(toDestination),
								rideType,
								riderType,
								totalDistance,
							}
						).then(response => {
							if(response.status === 1) {
								appContext.tellMessage(STR_SUCCESSFULLY_SENT[appContext.language]);
								appContext.navTo({
									item: 'side-view',
									subItem: 'view-ride-request',
									extraItem: response.data,
								})
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
					} else {
						appContext.tellError("Invalid route distance");
					}
				} else {
					appContext.tellError(STR_INVALID_TO_DESTINATION[appContext.language])
				}
			} else {
				appContext.tellError(STR_INVALID_FROM_DESTINATION[appContext.language])
			}
		} else {
			appContext.tellError(STR_INVALID_RIDE_TYPE[appContext.language]);
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		const timeout = setTimeout(() => {
			searchPlaces(getActiveDescription(), activeDestination);
		}, 500);

		return () => {
			clearTimeout(timeout);
		}
	}, [fromDescription, toDescription, activeDestination, googleMapsReady])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	if(ready) {
		return (
			<div
				ref={scrollContainerRef}
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<style>
					{`
						.rideRequestMapWrapper {
							position: relative !important;
							z-index: 0 !important;
							isolation: isolate !important;
						}

						.rideRequestMapWrapper .leaflet-container {
							position: relative !important;
							z-index: 0 !important;
						}

						.rideRequestMapWrapper .leaflet-pane,
						.rideRequestMapWrapper .leaflet-map-pane,
						.rideRequestMapWrapper .leaflet-tile-pane,
						.rideRequestMapWrapper .leaflet-overlay-pane,
						.rideRequestMapWrapper .leaflet-shadow-pane,
						.rideRequestMapWrapper .leaflet-marker-pane,
						.rideRequestMapWrapper .leaflet-tooltip-pane,
						.rideRequestMapWrapper .leaflet-popup-pane {
							z-index: 1 !important;
						}

						.rideRequestMapWrapper .leaflet-control-container {
							position: relative !important;
							z-index: 2 !important;
						}
					`}
				</style>

				<div className="container">
					<div className="row">
						<div className="col-md-12">
							{requestStage === 1 && (
								<>
									<div
										style={{
											display: "flex",
											background: "var(--lightColor)",
											borderRadius: 18,
											padding: 5,
											marginBottom: 14,
											marginTop: 14,
										}}
									>
										<button
											type="button"
											onClick={() => setRideType('ride')}
											className={rideType === 'ride' ? "btn btn-secondary" : "btn"}
											style={{
												flex: 1,
												borderRadius: 15,
												fontSize: 14,
												padding: "10px 8px",
											}}
										>
											<FaCar style={{ marginRight: 8 }} />
											{STR_RIDE[appContext.language]}
										</button>

										<button
											type="button"
											onClick={() => setRideType('delivery')}
											className={rideType === 'delivery' ? "btn btn-secondary" : "btn"}
											style={{
												flex: 1,
												borderRadius: 15,
												fontSize: 14,
												padding: "10px 8px",
											}}
										>
											<FaBox style={{ marginRight: 8 }} />
											{STR_DELIVERY[appContext.language]}
										</button>
									</div>

									<div
										style={{
											background: "var(--surfaceColor)",
											border: "1px solid var(--borderColor)",
											borderRadius: 18,
											padding: 15,
											marginBottom: 14,
										}}
									>
										{renderDestinationBlock({
											type: 'from',
											title: STR_PICKUP_LOCATION[appContext.language],
											placeholder: STR_WHERE_FROM[appContext.language],
											destination: fromDestination,
											icon: <FaLocationArrow />,
											hasBorder: true,
										})}

										{renderDestinationBlock({
											type: 'to',
											title: STR_DESTINY_LOCATION[appContext.language],
											placeholder: STR_WHERE_TO[appContext.language],
											destination: toDestination,
											icon: <FaMapMarkerAlt />,
										})}
									</div>

									<LocationSearchBox
										type={activeDestination}
										value={activeDestination === 'from' ? fromDescription : toDescription}
										placeholder={activeDestination === 'from' ? STR_WHERE_FROM[appContext.language] : STR_WHERE_TO[appContext.language]}
										searchingPlaces={searchingPlaces}
										placeSuggestions={placeSuggestions}
										onChange={updateDescription}
										onUseCurrentLocation={pickCurrentLocation}
										onPickSuggestedPlace={pickSuggestedPlace}
									/>

									<div
										className="rideRequestMapWrapper"
										style={{
											height: 340,
											borderRadius: 18,
											overflow: "hidden",
											marginTop: 14,
											marginBottom: 12,
											border: "1px solid var(--borderColor)",
											position: "relative",
											zIndex: 0,
											isolation: "isolate",
										}}
									>
										<MapContainer
											center={
												getMapDestinationData()
													? [getMapDestinationData().lat, getMapDestinationData().lng]
													: defaultCenter
											}
											zoom={13}
											scrollWheelZoom={false}
											dragging={false}
											touchZoom={false}
											doubleClickZoom={false}
											style={{
												height: "100%",
												width: "100%",
												zIndex: 0,
											}}
										>
											<TileLayer
												url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
											/>

											<MapClickHandler onPick={pickMapLocation} />
											<MapUpdater destination={getMapDestinationData()} />

											{fromDestination && (
												<Marker
													position={[fromDestination.lat, fromDestination.lng]}
													icon={markerIcon}
												/>
											)}

											{toDestination && (
												<Marker
													position={[toDestination.lat, toDestination.lng]}
													icon={markerIcon}
												/>
											)}
										</MapContainer>
									</div>

									<div
										style={{
											fontSize: 12,
											opacity: .7,
											marginBottom: 15,
											textAlign: "center",
										}}
									>
										{STR_MAP_HELPER_TEXT[appContext.language]}
									</div>

									<button
										type="button"
										onClick={continueToSummary}
										className="btn btn-primary"
										style={{
											width: "100%",
											borderRadius: 18,
											padding: 14,
											fontWeight: "bold",
											marginBottom: 20,
										}}
									>
										{STR_CONTINUE[appContext.language]}
									</button>
								</>
							)}

							{requestStage === 2 && (
								<>
									<div
										style={{
											display: "flex",
											alignItems: "center",
											marginTop: 14,
											marginBottom: 14,
										}}
									>
										<button
											type="button"
											onClick={() => setRequestStage(1)}
											className="btn btn-outline-primary"
											style={{
												width: 42,
												height: 42,
												borderRadius: 21,
												padding: 0,
												marginRight: 12,
											}}
										>
											<FaArrowLeft />
										</button>

										<div>
											<div
												style={{
													fontSize: 18,
													fontWeight: "bold",
												}}
											>
												{STR_CONFIRM_ORDER2[appContext.language]}
											</div>

											<div
												style={{
													fontSize: 12,
													opacity: .7,
												}}
											>
												{STR_CONFIRM_ORDER_HELP_TEXT[appContext.language]}
											</div>
										</div>
									</div>

									<div
										style={{
											background: "var(--surfaceColor)",
											border: "1px solid var(--borderColor)",
											borderRadius: 18,
											padding: 15,
											marginBottom: 14,
										}}
									>
										{renderRouteTypeBlock()}

										{renderRouteDestinationBlock({
											title: STR_PICKUP_LOCATION[appContext.language],
											destination: fromDestination,
											icon: <FaLocationArrow />,
											hasBorder: true,
										})}

										{renderRouteDestinationBlock({
											title: STR_DESTINY_LOCATION[appContext.language],
											destination: toDestination,
											icon: <FaMapMarkerAlt />,
										})}
									</div>

									<div
										style={{
											display: "grid",
											gridTemplateColumns: "1fr 1fr",
											gap: 12,
											marginBottom: 14,
										}}
									>
										<div
											style={{
												background: "var(--lightColor)",
												borderRadius: 18,
												padding: 15,
											}}
										>
											<div
												style={{
													fontSize: 12,
													opacity: .7,
												}}
											>
												{STR_DISTANCE[appContext.language]}
											</div>

											<div
												style={{
													fontSize: 22,
													fontWeight: "bold",
													marginTop: 4,
												}}
											>
												{getDistanceText()}
											</div>

											<div
												style={{
													fontSize: 12,
													opacity: .65,
												}}
											>
												{routeDistanceData && routeDistanceData.durationText ? routeDistanceData.durationText : "Route"}
											</div>
										</div>

										<div
											style={{
												background: "var(--secondaryColor)",
												color: "var(--onPrimaryColor)",
												borderRadius: 18,
												padding: 15,
											}}
										>
											<div
												style={{
													fontSize: 12,
													opacity: .85,
												}}
											>
												{STR_ESTIMATED_COST_TZS[appContext.language]}
											</div>

											<div
												style={{
													fontSize: 22,
													fontWeight: "bold",
													marginTop: 4,
												}}
											>
												{formatMoney(getEstimatedCost())}
											</div>

											<div
												style={{
													fontSize: 12,
													opacity: .85,
												}}
											>
												{getRiderTypeName(riderType)}
											</div>
										</div>
									</div>

									<div
										style={{
											background: "var(--lightColor)",
											borderRadius: 18,
											padding: 12,
											marginBottom: 14,
										}}
									>
										<div
											style={{
												fontSize: 16,
												fontWeight: "bold",
												marginBottom: 10,
											}}
										>
											{STR_CHOOSE_RIDER_TYPE[appContext.language]}
										</div>

										{renderRiderTypeOption({
											type: 'boda',
											title: 'Boda',
											description: STR_BODA_DESC[appContext.language],
											icon: <FaMotorcycle />,
										})}

										{renderRiderTypeOption({
											type: 'bajaj',
											title: 'Bajaj',
											description: STR_BAJAJ_DESC[appContext.language],
											icon: <FaTaxi />,
										})}

										{renderRiderTypeOption({
											type: 'cab',
											title: 'Cab',
											description: STR_CAB_DESC[appContext.language],
											icon: <FaCar />,
										})}
									</div>

									<button
										type="button"
										onClick={submit}
										className="btn btn-primary"
										style={{
											width: "100%",
											borderRadius: 18,
											padding: 14,
											fontWeight: "bold",
											marginBottom: 20,
										}}
									>
										<FaCheckCircle style={{ marginRight: 8 }} />
										{STR_CONFIRM_ORDER[appContext.language]}
									</button>
								</>
							)}
						</div>


					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		)
	}
}